import createReducer from 'store/create-reducer';
import { SET_BREADCRUMB } from './types';

const INITIAL_STATE = {
  breadcrumb: [],
};

export const resetBreadcrumb = () => (dispatch) => {
  dispatch({ type: SET_BREADCRUMB, breadcrumb: [] });
};

export const setBreadcrumb = breadcrumb => (dispatch) => {
  dispatch({ type: SET_BREADCRUMB, breadcrumb });
};

export const addBreadcrumb = element => (dispatch, getState) => {
  const { breadcrumb } = getState().navbar;
  breadcrumb.push(element);
  dispatch({ type: SET_BREADCRUMB, breadcrumb });
};

export const removeBreadcrumb = () => (dispatch, getState) => {
  const { breadcrumb } = getState().navbar;
  breadcrumb.pop();
  dispatch({ type: SET_BREADCRUMB, breadcrumb });
};

export const setBreadcrumbPosition = (element, position) => (dispatch, getState) => {
  const { breadcrumb } = getState().navbar;
  breadcrumb[position] = element;
  dispatch({ type: SET_BREADCRUMB, breadcrumb });
};

const ACTION_HANDLERS = {
  [SET_BREADCRUMB]: (state, { breadcrumb }) => ({
    ...state,
    breadcrumb,
  }),
};


export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/components/Navbar/modules/index.js